import './App.css';
import Error from './pages/Error';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from './pages/Home'
import About from './pages/About'
import Project from './pages/Project'


const array_pages = [{
  path: "/", element: <Home />
}, {
  path: "/home", element: <Home />
},
{
  path: "/about", element: <About />
}, {
  path: "/project", element: <Project />
},
{
  path: "*", element: <Error />
}
];
const router = createBrowserRouter(array_pages, undefined);

function App() {

  return (<>
    <div className='shine'>
      <div className='move-shine'></div>
    </div>
    <RouterProvider router={router} />
    
  </>
  );
}

export default App;
